import { createReducer, on } from "@ngrx/store";
import { UserSettings } from "app/global/user-settings.dto";
import { IUserPermissionDTO } from "../../../store/actions/IUser-data.dto";
import { uniqueArray } from "../../unique-array";
import * as UserPermissionsActions from './permission.actions';

export interface IUserPermissionState {
    userPermissions: IUserPermissionDTO[];
    roles: IRolesDto[],
}

export interface IRolesDto {
    id: number,
    name: string,
    permissions: IUserPermissionDTO[]
}


const initialState: IUserPermissionState = {
    userPermissions: [],
    roles: []
}
export const permissionsReducer = createReducer(
    initialState,
    on(UserPermissionsActions.refreshPermissionList, (state, {userData}) => ({
        ...state,
        userPermissions: collectPermissions(userData)
    })),
    on(UserPermissionsActions.fetchRolesSucceeded, (state, {roles}) => ({
        ...state,
        roles: roles,
    })),
    on(UserPermissionsActions.fetchRolesFailed, (state) => ({
        ...state,
        roles: initialState.roles,
    })),
);


/**
 * Collects and returns a unique array of user permissions from the given user data.
 *
 * This function aggregates permissions from both direct permissions and roles associated with the user.
 * It ensures that the returned array contains unique permissions based on the 'id' property.
 *
 * @param {UserSettings} userData - The user data containing direct permissions and roles.
 * @returns {IUserPermissionDTO[]} - A unique array of user permissions.
 */
function collectPermissions(userData: UserSettings):IUserPermissionDTO[]{
    return uniqueArray<IUserPermissionDTO>( [
        ...(userData?.direct_permissions  || []),
        ...((userData?.roles || []).reduce( (prev, currentValue)=> uniqueArray<IUserPermissionDTO>([
            ...prev,
            ...currentValue.permissions
        ], 'id') , [])) || []
    ],'id');
}